import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../config/site";

export const FaqList = ({ items = FAQS }) => (
  <Accordion type="single" collapsible data-testid="faq-accordion" className="divide-y divide-white/10 border-y border-white/10">
    {items.map((f, i) => (
      <AccordionItem key={f.q} value={`faq-${i}`} className="border-0">
        <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-base font-semibold text-slate-100 hover:no-underline hover:text-[#FF5500] sm:text-lg">
          {f.q}
        </AccordionTrigger>
        <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 pr-8 text-sm leading-relaxed text-slate-400 sm:text-base">
          {f.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
